import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first, Observable, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private roles: string[] = [];
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _authService: AuthService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        this.getRoles();
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                navigation.compact = navigation.compact.filter(x => {
                    if (x == null || x.role == undefined || this.userIsAuth(this.roles, x.role)) {
                        if (x.children) {
                            x.children = x.children.filter(y => y == null || y.role == undefined || this.userIsAuth(this.roles, y.role));
                        } else {
                            return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                        }
                    }
                    return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                });
                navigation.horizontal = navigation.horizontal.filter(x => {
                    if (x == null || x.role == undefined || this.userIsAuth(this.roles, x.role)) {
                        if (x.children) {
                            x.children = x.children.filter(y => y == null || y.role == undefined || this.userIsAuth(this.roles, y.role));
                        } else {
                            return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                        }
                    }
                    return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                });
                navigation.futuristic = navigation.futuristic.filter(x => {
                    if (x == null || x.role == undefined || this.userIsAuth(this.roles, x.role)) {
                        if (x.children) {
                            x.children = x.children.filter(y => y == null || y.role == undefined || this.userIsAuth(this.roles, y.role));
                        } else {
                            return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                        }
                    }
                    return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                });
                // navigation.default = navigation.default.filter(x => x == null || x.role == undefined || this.userIsAuth(roles, x.role));
                navigation.default = navigation.default.filter(x => {
                    if (x == null || x.role == undefined || this.userIsAuth(this.roles, x.role)) {
                        if (x.children) {
                            x.children = x.children.filter(y => y == null || y.role == undefined || this.userIsAuth(this.roles, y.role));
                        } else {
                            return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                        }
                    }
                    return x == null || x.role == undefined || this.userIsAuth(this.roles, x.role);
                });
                this._navigation.next(navigation);
            })
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    private getRoles(): void {
        this._authService.userRoles
        .pipe(first())
        .subscribe({
            next: (response: string[]) => {
                this.roles = response;
            },
            error: er => {
                console.log(er);
                this.roles = ['ROLE_GUEST'];
            }
        })
    }

    private userIsAuth(userRoles: string[], requiredRoles: string[]): boolean {
        if ( requiredRoles.includes('ALL') ) {
            return true;
        }
        requiredRoles.push('ROLE_SUPER_USER');
        if ( userRoles && userRoles.length > 0 ) {
            let result = userRoles.filter(x => requiredRoles.indexOf(x) > -1);
            return result.length > 0;
        }
        return requiredRoles.length > 0;
    }
}
